import { render, staticRenderFns } from "./search-to-add.vue?vue&type=template&id=22bfc14a&scoped=true"
import script from "./search-to-add.vue?vue&type=script&lang=js"
export * from "./search-to-add.vue?vue&type=script&lang=js"
import style0 from "./search-to-add.vue?vue&type=style&index=0&id=22bfc14a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bfc14a",
  null
  
)

export default component.exports